import { render, staticRenderFns } from "./SetOfCriteriaCopy.vue?vue&type=template&id=1d8f978d&"
import script from "./SetOfCriteriaCopy.vue?vue&type=script&lang=js&"
export * from "./SetOfCriteriaCopy.vue?vue&type=script&lang=js&"
import style0 from "./SetOfCriteriaCopy.vue?vue&type=style&index=0&id=1d8f978d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports